<template>
  <div id="app">
    <img
      src="./assets/music.png"
      alt=""
      class="music musicMove"
      @click="start()"
      :class="{ musicMove: move }"
      :style="{ 'animation-play-state': move == true ? 'running' : 'paused' }"
    />
    <audio
      loop="loop"
      ref="music"
      id="music"
      ontrols
      autoplay="autoplay"
      hidden="true"
    >
      <source :src="music" />
    </audio>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      music: require("./assets/bgm.mp3"),
      move: true,
    };
  },
  mounted() {
    window.onload = function () {
      const _audio = document.getElementById("music");
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          _audio.play();
        },
        false
      );
    };
    document.addEventListener(
      "touchstart",
      function (e) {
        _audio.play();
      },
      false
    );
    // this.$refs.music.addEventListener("canplay", () => {
    //   this.$nextTick(() => {
    //     this.$refs.music.play();
    //   });
    // });
  },
  methods: {
    start() {
      var audio = this.$refs.music;
      if (audio.paused) {
        audio.play();
        this.move = true; //audio.play();// 这个就是播放
      } else {
        audio.pause(); // 这个就是暂停
        this.move = false;
      }
    },
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  /* text-align: center; */
  background-size: 100% 100%;
  background-image: url("assets/bj.png");
  background-repeat: no-repeat;
}
.music {
  width: 10vw;
  position: fixed;
  top: 3vw;
  left: 3vw;
  z-index: 200000000000000;
}
.musicMove {
  animation: run 5s linear infinite;
  -webkit-animation: run 5s linear infinite;
}
@keyframes run {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes run {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue